exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.iqbal-min-width {\r\n  min-width: 105px !important;\n}\r\n", ""]);

// exports
